module.exports = __webpack_public_path__ + "img/ty.ce692e79.png";